// extracted by mini-css-extract-plugin
module.exports = {"root":"bd_bx","icon":"bd_bj","main-search-icon":"bd_dS","mainSearchIcon":"bd_dS","label-icon-default-filled":"bd_dT","labelIconDefaultFilled":"bd_dT"};